import { render, staticRenderFns } from "./DialogOpenScan.vue?vue&type=template&id=6b12b2da&scoped=true&"
import script from "./DialogOpenScan.ts?vue&type=script&lang=ts&"
export * from "./DialogOpenScan.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b12b2da",
  null
  
)

export default component.exports
import {QList,QItem,QBtn,QSeparator,QSpinnerAudio,ClosePopup} from 'quasar'
component.options.components = Object.assign({QList,QItem,QBtn,QSeparator,QSpinnerAudio}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
